import React from 'react'
import SponsorDesktop from '../Assets/Sponsors/sponsordesktop.webp'
import SponsorMobile from '../Assets/Sponsors/sponsormobile.webp'
import SponsorIpad from '../Assets/Sponsors/sponsordesktop.webp'
import Blob1 from '../Assets/blob1.webp'
import Blob2 from '../Assets/blob2.webp'
import Blob3 from '../Assets/blob3.webp'
import Blob4 from '../Assets/blob4.webp'

export default function Sponsors() {
  return (
    <div className='w-full h-full lg:mt-0 mt-[150px] block lg:px-[50px] px-[30px] justify-center py-[30px] lg:pb-0 pb-[100px] relative overflow-hidden font-[Amiri]'>
      <div></div>

      {/* Title without outline */}
      <h1 
        className='z-1 font-[400] lg:text-[120px] text-[50px] md:text-[50px] text-center mt-[50px]'
        style={{
          color: '#2B387D', // solid blue text color
        }}
      >
        SPONSORS
      </h1>
      {/* Sponsor Images */}
      <img src={SponsorDesktop} alt="" className='lg:block hidden'/>
      <img src={SponsorMobile} alt="" className='lg:hidden md:hidden block mx-auto overflow-auto' />
      <img src={SponsorIpad} alt="" className='hidden md:block lg:hidden mx-auto overflow-auto' />
    </div>
  )
}
